<template>
  <DashboardLayout>
    <p>Welcome to the Dashboard</p>
  </DashboardLayout>
</template>

<script>
import DashboardLayout from "../components/DashboardLayout.vue";

export default {
  components: { DashboardLayout }
};
</script>
